import { Link } from "react-router-dom";
import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

const RouterLink = styled(Link)`
  color: ${(p) => p.theme.colors.primaryBlue};
  text-decoration: none;
  font-size: ${(p) => p.theme.typography.fontSizes.M};
  &:hover {
    color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.8)};
  }
`;

export default RouterLink;
